const url_prefix = window.isdev
  ? location.host.replace('www', 'act')
  : 'act.tlsy.cy.com'

const url = {
  logState: `//${url_prefix}/site/login`, //二次验证登录
  logout: `//${url_prefix}/site/logout`, //登出

  userInfo: `//${url_prefix}/api/role/user/get-info`, //用户信息
  sceneList: `//${url_prefix}/api/role/scene/list`, //已领过的礼包列表
  sceneStatusInit: `//${url_prefix}/api/role/scene/init`, //礼包状态初始化
  submitScene: `//${url_prefix}/api/role/scene/set`, //领取礼包

  roleBind: `//${url_prefix}/api/role/user/bind`, //绑定角色
  roleList: `//${url_prefix}/api/role/user/get-list`, //绑定角色

  lottery: `//${url_prefix}/api/lottery/press`, //抽奖
  lotteryRecord: `//${url_prefix}/api/lottery/list`, //中奖纪录
  lotteryGift: `//${url_prefix}/api/lottery/gift`, //奖品列表

  submitGetlibao: `//${url_prefix}/api/gift/get`, //是否领取预约礼包
}

const source1 =
  location.search.indexOf('utm_source=') > -1
    ? location.search.split('utm_source=')[1].split('&')[0]
    : ''
const source2 =
  location.search.indexOf('&utm_medium=') > -1
    ? '-' + location.search.split('&utm_medium=')[1]
    : ''
const sourceStr = source1 + source2

const inviteSource =
  location.search.indexOf('code=') > -1
    ? location.search.split('code=')[1].split('&')[0]
    : ''

const scenesList = {
  1: {
    sceneType: '下载',
    btn: '[data-btn-lb-dl]',
  },
  2: {
    sceneType: '等级20',
    btn: '[data-btn-lb-l1]',
  },
  3: {
    sceneType: '等级50',
    btn: '[data-btn-lb-l2]',
  },
  4: {
    sceneType: '等级60',
    btn: '[data-btn-lb-l3]',
  },
  5: {
    sceneType: '等级70',
    btn: '[data-btn-lb-l4]',
  },
  6: {
    sceneType: '邀请1个',
    btn: '[data-btn-lb-i1]',
  },
  7: {
    sceneType: '邀请3个',
    btn: '[data-btn-lb-i2]',
  },
  8: {
    sceneType: '邀请5个',
    btn: '[data-btn-lb-i3]',
  },
  9: {
    sceneType: '邀请10个',
    btn: '[data-btn-lb-i4]',
  },
  11: {
    sceneType: '新职业天龙',
    btn: '[data-btn-lb-xzy]',
    tip: '少侠，您的角色职业无法领取该礼包。',
  },
  13: {
    sceneType: '老玩家回馈',
    btn: '[data-btn-lb-lwj]',
    tip: '少侠，您当前的角色不满足老玩家要求，无法领取该礼包。',
  },
  16: {
    sceneType: '邀请1个1.8.0',
    btn: '[data-btn-lb-i1-1]',
    tip: '当前账号未达到邀请人数要求。',
  },
  17: {
    sceneType: '邀请3个1.8.0',
    btn: '[data-btn-lb-i2-1]',
    tip: '当前账号未达到邀请人数要求。',
  },
  18: {
    sceneType: '邀请5人1.8.0',
    btn: '[data-btn-lb-i3-1]',
    tip: '当前账号未达到邀请人数要求。',
  },
  19: {
    sceneType: '邀请10人1.8.0',
    btn: '[data-btn-lb-i4-1]',
    tip: '当前账号未达到邀请人数要求。',
  },
  81: {
    sceneType: '邀约星宿',
    btn: '[data-btn-lb-81]',
  },
  82: {
    sceneType: '星宿聚集',
    btn: '[data-btn-lb-82]',
    tip: '少侠，未满足领取条件。',
  },
  83: {
    sceneType: '初入江湖',
    btn: '[data-btn-lb-83]',
    tip: '少侠，未满足领取条件。',
  },
  84: {
    sceneType: '师道传承',
    btn: '[data-btn-lb-84]',
    tip: '少侠，未满足领取条件。',
  },
}
const friendList = [
  '你们将一起共闯天龙江湖，可以结拜，结婚，做师徒，一起孵化宝宝，一起看风景，获得比单人游戏更丰厚奖励。',
  '你们将一起共闯天龙江湖，可以组队轻松完成老三环，杀马贼拿多倍经验，四绝庄缥缈峰少室山这些副本都将不在话下，获得比单人游戏更丰厚奖励。',
  '你们将一起共闯天龙江湖，可以组建帮会领工资拿分红，也可以一起在宋辽战争中大杀四方快意恩仇，获得比单人游戏更丰厚奖励。',
]

const customDialogSceneID = 81

let tipTimer = null
const setTip = (msg) => {
  clearTimeout(tipTimer)
  tipTimer = null
  $('.tip').hide().text('').text(msg).show()
  tipTimer = setTimeout(() => {
    $('.tip').fadeOut()
  }, 2000)
}

const bi = (p) => {
  _jc_ping.push(['_trackClick', location.href + '?p=' + p])
}

export {
  url,
  sourceStr,
  inviteSource,
  setTip,
  bi,
  scenesList,
  friendList,
  customDialogSceneID,
}
